import store from 'store'
;(function(root) {
  const x = {}

  x.showVersion = function(v) {
    const debug = store.get('debug') || {}
    debug.showVersion = !!v
    store.set('debug', debug)
  }

  root.X = x
})(window)
